import MenuItem from "@mui/material/MenuItem";
import styled from "@mui/material/styles/styled";

const SideNavMenuItem = styled(MenuItem)(({ theme }) => ({
  ...theme.typography.bodySecondaryMed,
  backgroundColor: "transparent",
  borderRadius: theme.corners.base,
  padding: 0,
  minHeight: 0,
  "&.Mui-focusVisible": {
    backgroundColor: "transparent",
  },
  "&:hover": {
    backgroundColor: "#F1F4FF",
  },
}));

export default SideNavMenuItem;
